import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { PricingItemViewType } from '../../../../../../models/pricing-item-view.type';
import { PricingUnitEnum } from '../../../../../../models/enums/pricing-unit.enum';

@Component({
  selector: 'jhi-upload-pricing-list',
  templateUrl: './upload-pricing-list.component.html',
  styleUrls: ['./upload-pricing-list.component.scss'],
})
export class UploadPricingListComponent implements OnInit {
  @Input() pricingItems: PricingItemViewType[] | undefined;
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;

  @Output() paginationChange = new EventEmitter<Pagination>();

  protected readonly MeasureUnit = PricingUnitEnum;

  public measureUnit: PricingUnitEnum = PricingUnitEnum.KILOGRAM;

  public ngOnInit() {
    if (this.pricingItems?.length) {
      this.measureUnit = this.pricingItems[0].offerMeasureUnit;
    }
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  trackId(index: number, item: PricingItemViewType): number {
    return item.id!;
  }

  isNullOrZero(number: number | undefined | null): boolean {
    return !number || number === 0;
  }
}
